import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import EldaMedina from "@/pages/EldaMedina";
import Invitado from "@/pages/Invitado";
import Episodios from "@/pages/Episodios";
import InvitadosPublic from "@/pages/InvitadosPublic";
import Contacto from "@/pages/Contacto";
import Libros from "@/pages/Libros";
import Reto from "@/pages/Reto";
import RetoReglas from "@/pages/RetoReglas";
import Admin, { AdminLogin, AuthCallback } from "@/pages/Admin";

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [location.pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/episodios" element={<Episodios />} />
          <Route path="/invitados" element={<InvitadosPublic />} />
          <Route path="/elda-medina" element={<EldaMedina />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/libros" element={<Libros />} />
          <Route path="/reto" element={<Reto />} />
          <Route path="/reto/reglas" element={<RetoReglas />} />
        </Route>
        <Route path="/invitado" element={<Invitado />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App bg-mp-black min-h-screen">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}
